import { filter } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { of, groupBy, mergeMap, reduce, map, toArray, first } from 'rxjs';
import { TankCoverageArea } from 'src/app/models/farmers-application.model';
import { BankDetailService } from 'src/app/services/bank-details.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from 'src/app/services/dashboard.service';
import { OnFarmMiService } from 'src/app/services/on-farm-mi.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-farmers-application',
  templateUrl: './farmers-application.component.html',
  styleUrls: ['./farmers-application.component.scss'],
  providers: [ConfirmationService],
})
export class FarmersApplicationComponent implements OnInit {
  farmersApplicatonForm: FormGroup;
  selectedPrimarySolarVendor: any;
  selectedSecondarySolarVendor: any;
  selectedSecondarySolarVendorId: any;
  // miSolarApplicationForm: FormGroup;
  solarApplicatonForm: FormGroup;
  miApplicatonForm: FormGroup;
  onFarmPondApplicatonForm: FormGroup;
  filteredVillage: any[];
  selectedVillage: any;
  villageList = [];
  // waterSourceTypeList: { waterSource: any; component: any[] }[] = [];
  waterSourceTypeList: any;
  componentList: any = [];
  miList: any = [];
  miVendorList: any = [];
  filteredmiVendorList: any = [];
  miDetailsList = [];
  solarVendorList = [];
  primarySolarVendorList = [];
  secondarySolarVendorList = [];
  componentSelected: any;
  addBankDialog: boolean;
  addFarmerGroupDialog: boolean;
  bankAccount: any;
  selectedVendor: any;
  bankAccountList: any = [];
  selectedBankAccounts: any = [];
  applicationSelected: any;
  pumpCapacityList: { name: string; code: string }[];
  solarMasterData: any = [];
  selectedWatersourceType: any;
  schemeMasterList: { type: any; data: any[] }[];
  // schemeMasterList: any = [];
  landIDList: any;
  selectedLandIdList: any;
  tankListMaster: any;
  coverageAreaSelected: TankCoverageArea = new TankCoverageArea();
  farmerDetailsList: any;
  selectedFarmerDetail: string[] = [];
  filteredFarmerDetail: any[];
  bankAccountSelected: any;
  selectedFarmerLandDetails: any[];
  selectedFarmersLandList: any[];
  selectedFarmersLandIdList: any[] = [];
  selectedGroupFarmersLandList: any[];

  watercourseApplicatonForm: FormGroup;
  overFlowPondApplicatonForm: FormGroup;
  canalOutletList: { canal: any; data: any[] }[];
  canalOutletListOrg: any = [];
  outletTypeList: any[];
  workTypeMasterList: any;
  villageCodeOutlets = [];
  villageCodeFarmer = [];
  selectedVillageCode: any;
  allSchemeMaster: any[] = [];
  selectedVillageName: any;
  selectedPondLand: any;
  selectedSolardLandId: any;
  applicationId: string;
  selectedSchemeId: any;
  consentUploadPath: any;
  miSelectedVendor: any;
  farmerPreviousSubsidies: any = [];
  farmerId: any;
  totalNumberOfFarmersInGroup: number;
  componentMaster: any;
  currentTotalArea: any;
  previousTotalArea: any;
  totalSubsidyArea: any
  public selectedMI: any;
  public vendorList: any = [];
  public selectedProgramId: any;
  public isDisabled=false
  public isSubmittedWaterCourseFrom: boolean = false;
  public isSubmittedOverFlowPondForm: boolean = false;
  public isSubmittedPondApplicatonForm: boolean = false;
  public isSubmittedSolarApplicatonFrom: boolean = false;
  allLandsOfApplication: any;
  public isVillhasCanal: boolean = true;
  public showWaterCourseForm: boolean = true;
  public showComponent: boolean = true;
  public isTargetReached: boolean = false;
  public isVillageSelected: boolean = false;
  public targetStatusBody={}
  ipAddress: any = '000.000.000';
  public farmerIDNotFound: boolean = false;              
  public overFlowPondList: any = [];

  public tubewellAppId: any = null;
  public isAppliedForUHBVN: boolean = false;
  public isUHBVNAppIdFound: boolean = false;

  public farmerMobileNo: any;
  public showClearUHBVNButton: boolean = false;

  public isFarmerTubewellLogin: boolean = false;
  public uhbvnToggleDisabledMode: boolean = false;

  public tankTypeMaster: any = [];

  public schemeTypeList: any = [];
  public applicationSchemeType: any;
  public newWaterSourceTypeList: any = [];
  public newComponentList: any = [];

  // public selectedApplicationType: any;
  public applicationTypeList: any = [];
  public isEditMode: boolean = false;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private confirmationService: ConfirmationService,
    private _fb: FormBuilder,
    private farmerAppSer: FarmersApplicationService,
    private messageService: MessageService,
    private farmersBankService: BankDetailService,
    private _personalDetalSer: FarmersDetailsService,
    private _dashboardService: DashboardService,
    private ofService: OnFarmMiService,
    private activityRecordService : ActivityRecordService,
    private loader: AppLoaderService,
    private ipService: IpAddressService,
    private cryptoJsService: CryptoJsService, 
  ) { }

  ngOnInit() {
    const encData = sessionStorage.getItem('dataF') ? JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF'))) : null;
    const farmerConfData = encData ? new Map(encData) : new Map();
    let isOwnMIFarmerLogin = farmerConfData.get('isOwnMIFarmerLogin') ? farmerConfData.get('isOwnMIFarmerLogin') : '';

    this.isFarmerTubewellLogin = isOwnMIFarmerLogin == '1' ? true : false;

    if(this.isFarmerTubewellLogin){
      this.isAppliedForUHBVN = true;
      this.uhbvnToggleDisabledMode = true;
    }else{
      this.uhbvnToggleDisabledMode = false;
    }

    this.getIP();
    
    let farmerData = farmerConfData.get('farmerDetails');

    
    this.farmerId = farmerConfData.get('Farmer_Id_');
    this.farmerMobileNo = farmerConfData.get('farmerPh');

    if(this.farmerId == undefined){
      this.farmerIDNotFound = true;
      return;
    }

    let mobile = farmerConfData.get('farmerPh') ? farmerConfData.get('farmerPh') : ''

    // this.activityRecordService.activityRecord(mobile, 'Add/Edit Application', this.farmerId, new Date(), 'Success');
    
    let appId = null;
    const id = this.route.snapshot.paramMap.get('appId');
   
    if (id) {
      appId = this.cryptoJsService.DecryptData(id);
      this.applicationId = this.cryptoJsService.DecryptData(id);
      this.isEditMode = true;
    }
    // this.route.queryParams.subscribe(params => {
    //   const encryptedMobile = params['appId'];
    //   if (encryptedMobile) {
    //     appId = this.cryptoJsService.DecryptData(encryptedMobile);
    //     this.applicationId = this.cryptoJsService.DecryptData(encryptedMobile);
    //     this.isEditMode = true;
    //   }else{
    //     // setTimeout(()=> this.onClickBack(), 1300);
    //     // this.appId = this.cryptoJsService.DecryptData(this.route.snapshot.paramMap.get('appId'));
    //   }
    // });
    
    this.loadSchemeTypeList();
    this.loadAppTypeList();
    this.getBankListOfFarmer();
    // this.getVillageData(this.farmerId);


    if (appId) {
      this.getSolarMaster();
      this.getTankTypeList();
      setTimeout(() => {
        this.populateForm(appId);
      }, 100);
    }
    else {
      this.getLandIds();
      this.getVillageData(this.farmerId);
    }

    // let appId = this.route.snapshot.paramMap.get('appId');
    // this.applicationId = appId;
    // this.getSchemeMaster();
    
    this.farmersApplicatonForm = this._fb.group({
      waterSourceType: [''],
      applicationType: [''],
      component: [''],
      gender: [''],
    });
    this.solarApplicatonForm = this._fb.group({
      controlType: ['', Validators.required],
      pump: ['', Validators.required],
      pumpType: ['', Validators.required],
      pumpCapacity: ['', Validators.required],
      primaryVendor: ['', Validators.required],
      secondaryVendor: [''],
      farmerShare: [''],
      solarId: ['', Validators.required],
      landId: ['', Validators.required],
    });
    this.miApplicatonForm = this._fb.group({
      mi: [''],
      vendor: [''],
      landId: [''],
    });

    this.watercourseApplicatonForm = this._fb.group({
      canal: ['', Validators.required],
      outlet: ['', Validators.required],
      workType: ['', Validators.required],
      checkBox: ['', Validators.required],
    });

    this.overFlowPondApplicatonForm = this._fb.group({
      overFlowPond: ['', Validators.required],
    });

    this.onFarmPondApplicatonForm = this._fb.group({
      landId: ['', Validators.required],
      sizeCoverageArea: ['', Validators.required],
      tankType: ['', Validators.required],
      topSize: [''],
      bottomSize: [''],
      depth: [''],
      waterCapacity: [''],
      tenativeCost: [''],
      tankId: [''],
      communityActualSubsidy: [''],
      communityPayment: [''],
      individualActualSubsidy: [''],
      individualPayment: [''],
    });

    this.waterSourceTypeList = [];

    // this.pumpCapacityList = [
    //   { name: '3 HP', code: '3 HP' },
    //   { name: '5 HP', code: '5 HP' },
    //   { name: '7.5 HP', code: '7.5 HP' },
    //   { name: '10 HP', code: '10 HP' },
    // ];

    this.getPastSubsidiesByFarmerId();
    this.getComponentMaster();

    // this.getSolarMaster(); //componentSelected?.Component?.includes('Solar')
    // this.getTankTypeList(); //componentSelected?.Component?.includes('Tank')

    this.getWorkTypeMasterData();  //selectedWatersourceType == STP || Canal
    // this.getAllMiVendors();
    // this.getAllTank();

    // this.getLandIds();
  }

  resetFromSubmissionState() {
    this.isSubmittedWaterCourseFrom = false;
    this.isSubmittedOverFlowPondForm = false;
    this.isSubmittedPondApplicatonForm = false;
    this.isSubmittedSolarApplicatonFrom = false;
  }

  get watercourseFormControls() {
    return this.watercourseApplicatonForm.controls;
  }

  get overFlowPondFormControls() {
    return this.overFlowPondApplicatonForm.controls;
  }

  get farmPondApplicatonFormControls() {
    return this.onFarmPondApplicatonForm.controls;
  }

  get solarApplicatonFormControls() {
    return this.solarApplicatonForm.controls;
  }

  populateForm(appId) {
    this.loader.start();
    this._dashboardService
      .getApplicationByAppId(appId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data.APP_ID) {
            //Populating Farmer Application Form
            this.applicationSchemeType = data?.AppSchemeType == 'Pond' ? 'Tank' : data?.AppSchemeType;
            this.onApplicationSchemeTypeSelected(this.applicationSchemeType, 'editMode', data);
            if(data?.ApplicantType == 'Individual'){
              this.applicationSelected = 'Individual';
            }else if(data?.ApplicantType == 'Community'){
              this.applicationSelected = 'Group';
            }else if(data?.ApplicantType == 'WUA/GOF'){
              this.applicationSelected = 'WUA';
            }

            this.onApplicationTypeSelected({value: this.applicationSelected});

            this.getVillageData(this.farmerId, 'editMode', data);
            // let val = {
            //   "VillageCode": "58733",
            //   "VillageName": "KHARAL"
            // }

            // this.onVillageSelect({
            //   VillageCode: val.VillageCode,
            //   VillageName: val.VillageName,
            // });
            // this.onVillageSelect({
            //   VillageCode: data.VillageData[0].VillageCode,
            //   VillageName: data.VillageData[0].VillageName,
            // });

            if (data.FarmerLand) {
              this.landIDList = [];
              this.allLandsOfApplication = data.FarmerLand;
              this.landIDList = this.transformLandIDData(data.FarmerLand);
            }

            // this.selectedSchemeId = data.Scheme_ID;
            //   let populatedScheme = this.allSchemeMaster.filter(
            //     (x) => x.Scheme_ID === data.Scheme_ID
            //   );

            // this.onApplicationTypeSelected({
            //   value: populatedScheme[0].Applicant_type,
            // });
            
            // this.onWaterSourceTypeSelected({
            //   value:
            //     this.waterSourceTypeList[populatedScheme[0].Water_Source - 1]
            //       .waterSource,
            // }, 'exists', populatedScheme);
            // const populatedComponent = this.componentList.filter(
            //   (x) => x.Scheme_ID === data.Scheme_ID
            // );
            // this.onComponentSelected({ value: populatedComponent[0] });
        
            // this.populateApllicationDataOnSchemeID(data, populatedScheme);
            return;
            if (data.Scheme_ID) {
              this.selectedSchemeId = data.Scheme_ID;
              let populatedScheme = this.allSchemeMaster.filter(
                (x) => x.Scheme_ID === data.Scheme_ID
              );

              if(populatedScheme.length == 0){

                this.loader.start();
                this.farmerAppSer.getSchemeMaster(data.Scheme_ID)
                  .pipe(first())
                  .subscribe({
                    next: (data) => {
                      populatedScheme = data;
                      this.loader.close();
                    },
                    error: (err) => {
                      this.loader.close();
                      this.messageService.add({
                        severity: 'error',
                        summary: 'Error Message',
                        detail: 'For the current Scheme ID data is not found.',
                      });
                      return;
                    },
                    complete: () => {
                      this.onApplicationTypeSelected({
                        value: populatedScheme[0].Applicant_type,
                      });
                      this.onVillageSelect({
                        VillageCode: data.VillageData[0].VillageCode,
                        VillageName: data.VillageData[0].VillageName,
                      });
                      this.onWaterSourceTypeSelected({
                        value:
                          this.waterSourceTypeList[populatedScheme[0].Water_Source - 1]
                            .waterSource,
                      }, 'exists', populatedScheme);
                      const populatedComponent = this.componentList.filter(
                        (x) => x.Scheme_ID === data.Scheme_ID
                      );
                      this.onComponentSelected({ value: populatedComponent[0] });
                  
                      this.populateApllicationDataOnSchemeID(data, populatedScheme);
                    }
                  });
              }else{
                this.onApplicationTypeSelected({
                  value: populatedScheme[0].Applicant_type,
                });
                if(data.VillageData == null){
                  this.messageService.add({
                    severity: 'error',
                    summary: 'Error Message',
                    detail: 'Village data of the selected Application Not Found.',
                  });
                  return;
                }
                this.onVillageSelect({
                  VillageCode: data.VillageData[0].VillageCode,
                  VillageName: data.VillageData[0].VillageName,
                });
                this.onWaterSourceTypeSelected({
                  value:
                    this.waterSourceTypeList[populatedScheme[0].Water_Source - 1]
                      .waterSource,
                });
                const populatedComponent = this.componentList.filter(
                  (x) => x.Scheme_ID === data.Scheme_ID
                );
                this.onComponentSelected({ value: populatedComponent[0] });
            
                this.populateApllicationDataOnSchemeID(data, populatedScheme);
              }
            }
            

          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Data error! Requested Application Not Found.',
            });
            return;
          }
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Requested Application Not Found.',
          });
          return;
        },
      });
  }

  populateApllicationDataOnSchemeID(data, populatedScheme){

    if (data.ConsentPath) {
      this.consentUploadPath = data.ConsentPath;
    }
    //populating Farmer Details
    if (data.Group_Datas) {
      data.FarmerLand = data.FarmerLand.map((x) => ({
        ...x,
        isDeleteModeOnly: true,
      }))
      data.Group_Datas.forEach((x) => {
        x.landDetails = data.FarmerLand.filter((land) => {
          return land.farmerId === x.Farmer_ID;
        });
        this.selectedFarmerLandDetails.push(x);
      });
      data.GroupTableData.forEach((x) => {
        this.selectedFarmersLandIdList.push({ Land_ID: x.LandID });
      });
      this.saveFarmerToGroup('editMode');
      // this.selectedFarmersLandList = data.GroupTableData;
    }

    //Populating MI Data
    this.miDetailsList = [];
    if (data.New_MI_Datas) {
      data.New_MI_Datas.forEach((x) => {
        let filteredList = this.miVendorList.filter((vendor) => {
          return vendor.Name == x.miVendorName;
        });
        this.miSelectedVendor = filteredList[0];
        let component = 0;
        this.componentMaster.forEach((val) => {
          if( x.programName == val.Program_Name){
            component =  val.Program_Id;
          }
        })

        if(x.VendorCode!=0 && x.VendorCode!=null ){
          let body = {
            mi: component,
            vendor: x.miVendorName,
            landId: x.LandID,
            vendorCode: x.VendorCode,
            vendorObject: filteredList[0],
            landData: x.landData,
            totalArea: x.totalArea,
            isEditMode: true,
          };
          this.miDetailsList.push(body);
        }
      });
    }

    //populating Bank
    this.onBankAccountSelected({
      value: data.FarmerBank?.accoNumber?.toString(),
    });

    //Populating Pond Farm
    if (data.OnFarm_Pond_Datas) {
      // let selectedLand = this.landIDList.filter((x) => {
      //   return x.Land_ID === data.OnFarm_Pond_Datas[0].LandID;
      // });
      let selectedLand = data.OnFarm_Pond_Datas;
      this.onFarmPondApplicatonForm.controls.landId.setValue(selectedLand[0].LandID);
      this.onPondLandIdSelected({ value: selectedLand[0] });

      let filteredTankMaster = this.tankTypeMaster.find((x) => x.Type == selectedLand[0].Type);
      // let filteredTankMaster = this.tankTypeMaster.find((x) => x.Type == "BRICK LINNING WITHOUT POLYTHENE")
      this.onFarmPondApplicatonForm.controls.tankType.setValue(filteredTankMaster);
      this.onSelectedTankType({ value: filteredTankMaster }, 'editMode', data);
      // this.tankListMaster.find((x => x.Tank_ID == data.OnFarm_Pond_Datas[0].TankID))?.Coverage_Area;
      // let filteredTankMaster = this.tankListMaster.filter((x) => {
      //   return (
      //     x.Coverage_Area == data.OnFarm_Pond_Datas[0].CoverageArea
      //   );
      // });
      // this.onCoverageAreaSelected({ value: filteredTankMaster[0] });
    }

    //populating Solar Form
    if (data.Solar_Pump_Datas) {
      // let selectedLand = this.landIDList.filter((x) => {
      //   return x.Land_ID === data.Solar_Pump_Datas[0].LandID;
      // });
      let selectedLand = data.Solar_Pump_Datas;
      this.solarApplicatonForm.controls.landId.setValue(
        selectedLand[0].Land_ID?selectedLand[0].Land_ID:selectedLand[0].LandID
      );
      this.solarApplicatonForm.controls.controlType.setValue(
        data.Solar_Pump_Datas[0].controlerType
      );
      this.solarApplicatonForm.controls.pump.setValue(
        data.Solar_Pump_Datas[0].type
      );
      this.solarApplicatonForm.controls.pumpType.setValue(
        data.Solar_Pump_Datas[0].pumpCategory
      );
      this.solarApplicatonForm.controls.pumpCapacity.setValue(
        data.Solar_Pump_Datas[0].pumpCapacity
      );
      this.validateAndGetSolarVendors('editMode', data);
      this.selectedPrimarySolarVendor =
        data.Solar_Pump_Datas[0].primaryVendor;
      
      // this.onPrimarySolarVendorChange({value: data.Solar_Pump_Datas[0].primaryVendor}, 'editMode', data);
      // this.selectedSecondarySolarVendor =
      //   data.Solar_Pump_Datas[0].secondaryVendor;

      this.solarApplicatonForm.controls.farmerShare.setValue(
        data.Solar_Pump_Datas[0].farmerShare
      );
    }

    if (data?.Water_Course_Datas) {
      this.watercourseApplicatonForm.controls.canal.setValue(data?.Water_Course_Datas[0]?.Canal_Outlet_Name);
      this.watercourseApplicatonForm.controls.outlet.setValue(data?.Water_Course_Datas[0]?.Outlet_Code);
      this.watercourseApplicatonForm.controls.workType.setValue(data?.Water_Course_Datas[0]?.Work_type);
    }

    if (data?.overFlowPond_Datas) {
      this.overFlowPondApplicatonForm.controls.overFlowPond.setValue(data?.overFlowPond_Datas[0]?.recordId);
    }
  }

  //get all list
  getBankListOfFarmer() {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let farmerData = farmerConfData.get('farmerDetails');

    let appNo = farmerConfData.get('Farmer_Id_') as string;
    // this.farmerMobileNo = farmerConfData.get('farmerPh');

    this.loader.start();
    this.farmersBankService.getBankDetails(appNo).subscribe((res) => {
      this.loader.close();
      this.bankAccountList = res.map((r) => {
        return { ...r, displayName: r.Account_NO + ' - ' + r.Bank_NAME };
      });
    });
  }

  getAllOutletData(villageCode: any) {
    this.loader.start();
    this.farmerAppSer.GetAllOutletDetails(villageCode).subscribe((res) => {
      of(...res)
        .pipe(
          groupBy((p: any) => p.canal),
          mergeMap((group$) =>
            group$.pipe(reduce((acc, cur) => [...acc, cur], [`${group$.key}`]))
          ),
          map((arr) => ({ canal: arr[0], data: arr.slice(1) })),
          toArray()
        )
        .subscribe((p) => {
          this.canalOutletList = p;
          this.loader.close();
          if(this.applicationId){
            this.onCanalOutletSelected({ value: this.watercourseApplicatonForm.controls.canal.value });
          }
        });
    });
  }

  listAllOutletData() {
    this.loader.start();
    this.farmerAppSer.LetAllOutletDetails().subscribe((res) => {
      of(...res)
        .pipe(
          groupBy((p: any) => p.canal),
          mergeMap((group$) =>
            group$.pipe(reduce((acc, cur) => [...acc, cur], [`${group$.key}`]))
          ),
          map((arr) => ({ canal: arr[0], data: arr.slice(1) })),
          toArray()
        )
        .subscribe((p) => {
          this.canalOutletList = p;
          this.loader.close();
          if(this.applicationId){
            this.onCanalOutletSelected({ value: this.watercourseApplicatonForm.controls.canal.value });
          }
        });
    });
  }

  getWorkTypeMasterData() {
    this.loader.start();
    this.farmerAppSer.GetWorktypeMaster().subscribe((res) => {
      res = res.map(value => ({
        ...value,
        disabled: value?.workTypeID != 4 ? true : false
      }))
      this.workTypeMasterList = res
      this.loader.close();
    });
  }
  getComponentMaster() {
    this.loader.start();
    this.farmerAppSer.getComponentMaster().subscribe((res) => {
      this.componentMaster = res;
      this.miList = res;
      this.loader.close();
    });
  }
  getLandIds() {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let farmerData = farmerConfData.get('farmerDetails');

    let appNo = farmerConfData.get('Farmer_Id_');
    // this.farmerMobileNo = farmerConfData.get('farmerPh');

    // this.farmerAppSer.getFarmersLandId(appNo).subscribe((res) => {
    this.loader.start(); 
    this.farmerAppSer.getNotUsedLandsByFarmerID(appNo).subscribe((res) => {
          this.loader.close();
            this.landIDList = this.selectedLandIdList = this.transformLandIDData(
              res.Table
            );
      
            let villageCodeList = this.landIDList?.map((res) => res.Village_Code);
            // this.getAllOutletData(villageCodeList);
      });
  }

  transformLandIDData(inputData) {
    return inputData?.map((r) => {
      return {
        ...r,
        displayName:
          'Village Name:' +
          (r.VillageName ? r.VillageName : this.selectedVillageName )+
          ' - Killa No:' +
          ((r.Killa_No ? r.Killa_No : r.killaNo)
            ? r.Killa_No
              ? r.Killa_No
              : r.killaNo
            : r.KillaNo) +
          ' - Morabba No:' +
          ((r.Morabba_No ? r.Morabba_No : r.morabbaNo)
            ? r.Morabba_No
              ? r.Morabba_No
              : r.morabbaNo
            : r.MorabbaNo),
        isDifferentFarmerLand: r.FarmerID != this.farmerId ? true : false,
      };
    });
  }

  getSchemeMaster(...args) {
    this.loader.start();
    this.farmerAppSer.getSchemeMaster().subscribe((res) => {
      this.allSchemeMaster = res;
      of(...res)
        .pipe(
          groupBy((p: any) => p.Applicant_type),
          mergeMap((group$) =>
            group$.pipe(reduce((acc, cur) => [...acc, cur], [`${group$.key}`]))
          ),
          map((arr) => ({ type: arr[0], data: arr.slice(1) })),
          toArray()
        )
        .subscribe((p) => {
          this.schemeMasterList = p;
          if(args[0] == 'editMode') {
            let val = this.allSchemeMaster.find((x => x.Scheme_ID == args[1]?.Scheme_ID));
            this.applicationSelected = this.schemeMasterList.find((x) => x.type == val?.Applicant_type)?.type;

            this.onApplicationTypeSelected({ value: this.applicationSelected }, ...args);
          }
          this.loader.close();
        });
    });
  }

  getPastSubsidiesByFarmerId() {
    if (this.farmerId) {
      this.loader.start();
      this.ofService
        .GetFarmerPastSubsidyByFarmerId(this.farmerId)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.farmerPreviousSubsidies = data;
            this.loader.close();
          },
          error: () => {
            this.loader.close();
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Data error! Farmer Previous Subsidies not loaded.',
            });
          },
        });
    }
  }

  getVillageData(farmerId, ...args) {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let mobile = farmerConfData.get('farmerPh') ? farmerConfData.get('farmerPh') : '';
    this.loader.start();
    this._personalDetalSer.getVillageBasedOnFarmerId(farmerId)
    .pipe(first())
    .subscribe({
      next: (res) => {
        this.loader.close();
        // this.activityRecordService.activityRecord(
        //   mobile,
        //   'Get Village Based On Farmer Id',
        //   this.farmerId,
        //   new Date(),
        //   JSON.stringify(res)
        // );

        this.villageList = res;
        this.filteredVillage = [...this.villageList];

        if(args[0] == 'editMode') {
          let val = this.villageList.find((x => x.VillageCode == args[1]?.VillageData[0]?.VillageCode));
          this.selectedVillage = val;
          this.onVillageSelect(val, ...args);
          
        }
      },
      error: (err) => {
        this.loader.close();
        // this.activityRecordService.activityRecord(
        //   mobile,
        //   'Get Village Based On Farmer Id',
        //   this.farmerId,
        //   new Date(),
        //   err
        // );

        this.messageService.add({
          severity: 'error',
          summary: 'Village Error Message. Please add the land details first and try again',
          detail: err,
        });
      },
    });
    // this._personalDetalSer.getVillageBasedOnFarmerId(farmerId).subscribe((res) => {
    //   this.villageList = res;
    //   this.loader.close();
    //   this.filteredVillage = [...this.villageList];

      // if (!window.sessionStorage.getItem('villageMaster')) {
      //   window.sessionStorage.setItem('villageMaster', JSON.stringify(res));
      // }
    // });
  }
  filterVillage(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.villageList.length; i++) {
      const village = this.villageList[i];
      if (village.VillageName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(village);
      }
    }
    this.filteredVillage = filtered;
  }
  filterMIVendor(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.miVendorList.length; i++) {
      const vendor = this.miVendorList[i];
      if (vendor.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(vendor);
      }
    }
    this.filteredmiVendorList = filtered;
  }
  GetAllFarmerDetails(villageCode: any) {
    this.selectedFarmerLandDetails = [];
    this.farmerDetailsList = [];
    // if (this.applicationId) {
      // this.landIDList = this.transformLandIDData(this.allLandsOfApplication);
    // } 
    // else {
      if (this.applicationSelected === 'Individual') {
        this.getFarmerLandByFarmerIds();
      } else {
        this.loader.start();
        this.farmerAppSer.GetFarmerAndLandByVillageCode(villageCode).subscribe({
          next: (data) => {
            this.loader.close();
            if (data) {
              this.farmerDetailsList = data;
              this.getFarmerLandByFarmerIds();
            }
          },
          error: (err) => {
            this.loader.close();
          },
        });
      }
    // }
  }
  onVillageSelect(val: any, ...args) {
    this.isVillageSelected = true;
    this.resetApplication();
    this.villageCodeFarmer = [];
    this.selectedVillageName = val.VillageName;
    this.selectedVillageCode = val.VillageCode;
    this.selectedVillage = val;
    this.selectedFarmerLandDetails = [];
    this.farmerDetailsList = [];
    this.selectedWatersourceType = null;
    this.componentSelected = null;
    this.villageCodeFarmer.push(val.VillageCode);
    this.GetAllFarmerDetails(this.villageCodeFarmer);
    // this.getAllOutletDataN(this.villageCodeFarmer);
    this.getAllOutletDataN(this.villageCodeFarmer);
    this.loadNewWaterSourceTypeList(this.applicationSchemeType, this.applicationSelected, ...args);
  }

  // getAllMiVendors() {
  //   this.farmerAppSer.getAllMiVendors().subscribe({
  //     next: (data) => {
  //       if (data) {
  //         this.miVendorList = data;
  //         this.filteredmiVendorList = [...this.miVendorList];
  //       }
  //     },
  //     error: (err) => {
  //     },
  //   });
  // }
  getAllSolarVendors() {
    this.loader.start();
    this.farmerAppSer.getAllSolarVendors().subscribe({
      next: (data) => {
        this.loader.close();
        if (data) {
          this.solarVendorList = data;
        }
      },
      error: (err) => {
        this.loader.close();
      },
    });
  }

  getPrimarySolarVendors(...args) {
    this.primarySolarVendorList = [];

    let solarMasteredFilteredData = this.getFarmerShare();
    if (solarMasteredFilteredData) {
      this.solarApplicatonForm.patchValue({
        farmerShare: solarMasteredFilteredData.Farmers_Share,
      });
      this.solarApplicatonForm.patchValue({
        solarId: solarMasteredFilteredData.Solar_ID,
      });

      this.loader.start();
      this.farmerAppSer
        .getPrimarySolarVendors(solarMasteredFilteredData.Solar_ID)
        .subscribe({
          next: (data) => {
            this.loader.close();
            if (data) {
              this.primarySolarVendorList = data;
              if (this.applicationId) {
                this.onPrimarySolarVendorChange({
                  value: this.selectedPrimarySolarVendor,
                }, ...args);
              }

            }
          },
          error: (err) => {
            this.loader.close();
          },
        });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! Solar ID Not Found For selected Combination',
      });
    }
  }

  onPrimarySolarVendorChange(event, ...args) {  
    this.selectedPrimarySolarVendor = event.value;
    let solarMasteredFilteredData = this.getFarmerShare();
    let selectedPrimaryVendor = this.primarySolarVendorList.filter(vendor => {
      return vendor.Primary_Vendor === event.value
    })
    this.secondarySolarVendorList = [];
    this.selectedSecondarySolarVendor = null;
    if (selectedPrimaryVendor.length) {
      this.getSecondarySolarVendors(selectedPrimaryVendor[0].pid, ...args);
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'PID value is unknown for Selcted Primary Vendor, Hence Secondary Vendor is not known',
      });
      return;
    }

  }

  onSecondarySolarVendorChange(event) {
    this.selectedSecondarySolarVendor = event.value;
    let selectedSolarVendor = this.secondarySolarVendorList.filter((x) => {
      return x.Secondary_Vendor === this.selectedSecondarySolarVendor;
    });
    this.selectedSecondarySolarVendorId = selectedSolarVendor[0].sid;
  }

  getSecondarySolarVendors(solarId: any, ...args) {
    this.loader.start();
    this.farmerAppSer.getSecondarySolarVendors(solarId).subscribe({
      next: (data) => {
        this.loader.close();
        if (data) {
          this.secondarySolarVendorList = data;
          // if (this.selectedSecondarySolarVendor) {
          //   let selectedSolarVendor = this.secondarySolarVendorList.filter(
          //     (x) => {
          //       return x.Secondary_Vendor === this.selectedSecondarySolarVendor;
          //     }
          //   );
          //   this.selectedSecondarySolarVendorId = selectedSolarVendor[0].sid;
          // }

          if(args[0] == 'editMode') {
            let selectedSolarVendor = this.secondarySolarVendorList.filter(
              (x) => x.Secondary_Vendor == args[1]?.Solar_Pump_Datas[0]?.secondaryVendor);
            
            this.selectedSecondarySolarVendor = selectedSolarVendor[0]?.Secondary_Vendor;
          }
        }
      },
      error: (err) => {
        this.loader.close();
      },
    });
  }

  // getAllTank() {
  //   this.loader.start();
  //   this.farmerAppSer.getAllTank().subscribe({
  //     next: (data) => {
  //       this.tankListMaster = data;
  //       this.loader.close();
  //     },
  //     error: (err) => {
  //       this.loader.close();
  //     },
  //   });
  // }

  getTankListBasedOnType(val, ...args) {
    this.loader.start();
    this.farmerAppSer.getAreaBasedOnTankType(val).subscribe({
      next: (data) => {
        this.tankListMaster = data;
        if(args[0] == "editMode") {
          let filteredTankMaster = this.tankListMaster.find((x) => x.Coverage_Area == args[1]?.OnFarm_Pond_Datas[0]?.CoverageArea);
          this.onFarmPondApplicatonForm.controls.sizeCoverageArea.setValue(filteredTankMaster);

          this.onCoverageAreaSelected({ value: filteredTankMaster });
        }
        this.loader.close();
      },
      error: (err) => {
        this.loader.close();
      },
    });
  }

  getTankTypeList() {
    this.loader.start();
    this.farmerAppSer.getTankType()
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data?.length > 0) {
            this.tankTypeMaster = data;
          } else {
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Tank Type Data Not Loaded' });
            this.tankTypeMaster = [];
          }
        },
        error: (err) => {
          this.loader.close();
          this.tankTypeMaster = [];

          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
        }
      });
  }

  getSolarMaster() {
    this.loader.start();
    this.farmerAppSer.getSolarMaster().subscribe({
      next: (data) => {
        this.loader.close();
        if (data) {
          this.solarMasterData = data;
        }
      },
      error: (err) => {
        this.loader.close();
      },
    });
  }

  openPreviousConsent(url) {
    window.open(url, '_blank');
  }

  downloadConsent() {
    window.open('/assets/consent.pdf', '_blank');
  }

  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let phNo = farmerConfData.get('farmerPh') ? farmerConfData.get('farmerPh') : '';

    this.loader.start();
    this._personalDetalSer
      .uploadFile(data, phNo, formcontrol)
      .subscribe((resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200) {
          this.consentUploadPath = resp.data;
        }
      });
    uploadElement.clear();
  }

  onFarmersApplicationFormSubmit() {

    // check validations
    if (this.componentSelected.Component.includes('MI')) {
      if (this.miDetailsList.length == 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message! MI list is empty',
          detail: 'Please Add MI details first',
        });
        return;
      }
    }

    if (this.componentSelected.Component.includes('Tank')) {
      if (this.onFarmPondApplicatonForm.invalid) {
        this.isSubmittedPondApplicatonForm = true;
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message! Invalid',
          detail: 'Please Fill Tank Application Form Properly.',
        });
        return;
      }
    }

    if (this.componentSelected.Component.includes('Solar')) {
      if (this.solarApplicatonForm.invalid) {
        this.isSubmittedSolarApplicatonFrom = true;
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message! Invalid',
          detail: 'Please Fill Solar Application Form Properly.',
        });
        return;
      }
    }




    //gettting primary solar vendor Id
    let filteredPrimarySolarVendor: any = this.primarySolarVendorList.filter(x => x.Primary_Vendor === this.selectedPrimarySolarVendor);

    //Populating Water 
    let waterCouseDetail = []
    if (this.selectedWatersourceType == 'Canal' || this.selectedWatersourceType == 'STP') {
      if (this.watercourseApplicatonForm.invalid) {
        this.isSubmittedWaterCourseFrom = true;
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message! Invalid',
          detail: 'Please Fill  Water Course Form Properly.',
        });
        return;
      }
      else {
        let body = {
          "outlet_Code": this.watercourseApplicatonForm.controls.outlet.value,
          "work_type": this.watercourseApplicatonForm.controls.workType.value
        }
        waterCouseDetail.push(body)
      }
    }

    let overFlowPondDetail = [];
    if (this.selectedWatersourceType == 'Over Flow Pond') {
      if (this.overFlowPondApplicatonForm.invalid) {
        this.isSubmittedOverFlowPondForm = true;
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message! Invalid',
          detail: 'Please Fill Over Flow Pond Form Properly.',
        });
        return;
      } else {
        let body = {
          recordId: this.overFlowPondApplicatonForm.controls.overFlowPond.value,
        };
        overFlowPondDetail.push(body);
      }
    }

    //validation for bank details
    if (this.bankAccountSelected == undefined || this.bankAccountSelected == null) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message! Invalid',
        detail: 'Please Select the Bank Details.',
      });
      return;
    }

    //Validation for Group: Consent Form Path shouldnt be null
    if (this.applicationSelected === 'Group') {
      if (!this.consentUploadPath) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Please upload Consent Form',
        });
        return;
      }
    }

    //Validate if Total subsidy area is less than 12.5
    this.totalSubsidyArea = 0;
    this.miDetailsList.forEach((mi) => {
      this.totalSubsidyArea = this.totalSubsidyArea + Number(mi.totalArea);

    });
    this.farmerPreviousSubsidies.forEach((subsidy) => {
      if (subsidy.DiffYear < 8) {
        if(subsidy.AppId != this.applicationId && subsidy?.Active == true) {
          this.totalSubsidyArea = this.totalSubsidyArea + Number(subsidy.Area);
        }
      }
    });
    //For Group Application, the total max subsidy allowed is calculated by No. of Farmer in Group Multiplied by '12.5' and Subtracting farmer previous subsidies from last 8 years
    if (this.applicationSelected === 'Group') {
      let maxSubsidyAreaForGroup = (this.totalNumberOfFarmersInGroup + 1) * 12.5
      if (maxSubsidyAreaForGroup > 0) {
        if (this.totalSubsidyArea > maxSubsidyAreaForGroup) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail:
              'Total Area Eligible for subsidy should be Less than ' + Number(maxSubsidyAreaForGroup) + 'Acre .For ' + this.totalNumberOfFarmersInGroup + 'Farmers (Group Application). You are applying for ' +
              Number(this.totalSubsidyArea) +
              ' Acre. \n\n Contact Department',
          });
          return;
        }
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail:
            'Max SubSidy Area Cant be calculated for Group. Contact Department',
        });
        return;
      }
    } else {
      if (this.totalSubsidyArea > 12.5) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail:
            'Total Area Eligible for subsidy should be Less than 12.5 Acre. You are applying for ' +
            Number(this.totalSubsidyArea) +
            ' Acre. \n\n Contact Department',
        });
        return;
      }
    }

    let totalArea = 0;
    this.miDetailsList?.forEach((mi) => {
      totalArea = totalArea + Number(mi.totalArea);
    });

    let addedTotalLand = 0;
    this.selectedFarmersLandList?.forEach((land) => {
      addedTotalLand = addedTotalLand + Number(land.land_area);
    })
    

    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    const userID_ = farmerConfData.get('userID');

    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const userId = loginDetails.get('User_name_while_login') ? loginDetails.get('User_name_while_login') : null;
    const isAtalBhujalLogin = loginDetails.get('isAtalBhujal') ? loginDetails.get('isAtalBhujal') : null;
    const isVendorLogin = loginDetails.get('isVendor') ? loginDetails.get('isVendor') : null;
    
    
    //Validation for 'MI' if total area is less than 1 acre
    // if (Number(totalArea) < 1 && Number(totalArea) != 0) {
    //   this.messageService.add({
    //     severity: 'error',
    //     summary: 'Error Message',
    //     detail:
    //       'Data error! Total Area for MI form cannot be less than 1 Acre. ' +
    //       Number(totalArea),
    //   });
    //   return;
    // }

    //Validation for 'Pond' if total area is less than 5 acre
    // if (this.componentSelected.Component.includes('Tank')) {
    //   if (Number(totalArea)+Number(addedTotalLand) < this.onFarmPondApplicatonForm.value['sizeCoverageArea'].Coverage_Area && (Number(totalArea)+Number(addedTotalLand)) != 0) {
    //     this.messageService.add({
    //       severity: 'error',
    //       summary: 'Error Message',
    //       detail:
    //         `Data error! Total Area for Tank form should be ${this.onFarmPondApplicatonForm.value['sizeCoverageArea'].Coverage_Area} Acre. Current Total Area is ` +
    //         (Number(totalArea)+Number(addedTotalLand)),
    //     });
    //     return;
    //   }
    // }


    let appNo = farmerConfData.get('Farmer_Id_');
    // this.farmerMobileNo = farmerConfData.get('farmerPh');

    let farmersApplicationToSubmit = {
      apP_ID: this.applicationId ? this.applicationId : '',
      uhbvnAppid: this.tubewellAppId ? this.tubewellAppId : '',
      farmer_ID: appNo,
      applicant_type: this.applicationSelected,
      scheme_Code: this.componentSelected.Scheme_ID,
      user_ID: userId ? userId : (userID_ == 'ownMIfarmer' ? 'farmer' : userID_),
      is_Atal: isAtalBhujalLogin == '1' || isVendorLogin == '1' ? true : false,
      netWork_Id: this.ipAddress, 
      terminal_Id: this.ipAddress,
      consentPath: this.consentUploadPath ? this.consentUploadPath : '',
      group_Datas: this.selectedGroupFarmersLandList,
      water_Course_Datas: waterCouseDetail,
      overFlowPond_Datas: overFlowPondDetail,
      onFarm_Pond_Datas: this.componentSelected.Component.includes('Tank')
        ? [
          {
            land_ID: this.onFarmPondApplicatonForm.value['landId'],
            tank_id: this.onFarmPondApplicatonForm.value['tankId'],
          },
        ]
        : [],
      solar_Pump_Datas: this.componentSelected.Component.includes('Solar')
        ? [
          {
            solar_ID: +this.solarApplicatonForm.value['solarId'],
            solar_Vendor_id: filteredPrimarySolarVendor[0].pid,
            solar_Vendor_Secondry_ID: this.selectedSecondarySolarVendorId,
            land_ID: this.solarApplicatonForm.controls.landId.value,
          },
        ]
        : [],
      new_MI_Datas: this.miDetailsList.map((r) => {
        return {
          // new_MI_System: this.miList.filter(
          //   (res) => res.Program_Name === r.mi
          // )[0]?.Program_Id,
          land_ID: r.landId,
          new_MI_System: r.mi,
          vendor_Code: r.vendorId?.Vendor_Code
            ? r.vendorId?.Vendor_Code
            : r.vendorCode,
        };
      }),
      bank_Datas: [
        {
          bank_Data: this.bankAccountSelected?.toString(),
        },
        // {
        //   "farmer_ID": appNo,
        //   "bank_ID": this.bankAccountSelected
        // }
      ],
    };

    this.postFarmersRegistrationData(farmersApplicationToSubmit);
  }
  getCurrentSubsidyArea() {
    let currentArea = 0
    this.miDetailsList.forEach((mi) => {
      currentArea = currentArea + Number(mi.totalArea);
    });
    return currentArea
  }
  getPreviousSubsidyArea() {
    let previousSubsidyArea = 0
    this.farmerPreviousSubsidies.forEach((subsidy) => {
      if (subsidy.DiffYear < 8) {
        if (subsidy.AppId != this.applicationId) {
          previousSubsidyArea = previousSubsidyArea + Number(subsidy.Area);
        }
      }
    });
    return previousSubsidyArea
  }
  getTotalSubsidyArea() {
    let totalArea = 0
    this.miDetailsList.forEach((mi) => {
      totalArea = totalArea + Number(mi.totalArea);
    });
    this.farmerPreviousSubsidies.forEach((subsidy) => {
      if (subsidy.DiffYear < 8) {
        if (subsidy.AppId != this.applicationId) {
          totalArea = totalArea + Number(subsidy.Area);
        }
      }
    });
    return totalArea
  }
  postFarmersRegistrationData(farmersApplicationToSubmit) {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let mobile = farmerConfData.get('farmerPh') ? farmerConfData.get('farmerPh') : '';

    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(farmersApplicationToSubmit))
    }

    this.loader.start();
    this.farmerAppSer
      .postFarmersRegistrationData(reqBodyAfterEncypt)
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data.startsWith('S:')) {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });
            this.resetApplication();
            setTimeout(() => {
              // this.router.navigate(['farmer/dashboard']);
              this.router.navigate(['farmer/bank-details']);
            }, 1000);
          }
          else if(data.includes('deadlocked') || data.includes('deadlock')){
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Oops!!! Something went wrong. Please try again later.',
            });
          }
          else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: data,
            });
          }
          this.activityRecordService.activityRecord(mobile, 'Farmer Application Details Add/Edit', this.farmerId, new Date(), data, farmersApplicationToSubmit);

        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(mobile, 'Farmer Application Details Add/Edit', this.farmerId, new Date(), err, farmersApplicationToSubmit);

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Farmer Application not saved.',
          });
        },
      });
  }

  resetApplication() {
    this.solarApplicatonForm.reset();
    this.onFarmPondApplicatonForm.reset();
    this.miDetailsList = [];
    this.isTargetReached = false;
  }

  getSolarVendorId() {
    let id = this.solarVendorList.filter(
      (r) =>
        this.solarApplicatonForm.value['secondaryVendor'].toLowerCase() ===
        r.Secondary_Vendor.toLowerCase() &&
        this.solarApplicatonForm.value['primaryVendor'].toLowerCase() ===
        r.Primary_Vendor.toLowerCase()
    )[0]?.Id;
    return id;
  }

  onBankAccountSelected(event) {
    this.bankAccountSelected = event.value;
  }

  onWaterSourceTypeSelected(event, ...args) {
    this.componentSelected = null;
    this.selectedWatersourceType = event.value;
    this.showComponent = true;
    this.showWaterCourseForm = true;

    let selectedWatersourceId = this.newWaterSourceTypeList.filter((val) => val.Source_Name == this.selectedWatersourceType);

    if(selectedWatersourceId.length > 0){
      let schemeType = this.applicationSchemeType;
      if(schemeType == 'MI'){
        schemeType = 'MI';
      }else if(schemeType == 'Tank'){
        schemeType = 'Pond';
      }else{
        schemeType = 'Both';
      }
  
      this.loadNewComponentList(selectedWatersourceId[0]?.Source_ID, this.applicationSelected, schemeType, ...args);
    }

    if(this.canalOutletList){
      if(this.selectedWatersourceType == "STP"){
        let val = this.canalOutletListOrg.filter(val => val?.outletName == "STP");
        this.groupByCanal(val);
      }else if(this.selectedWatersourceType == "Canal"){
        let val = this.canalOutletListOrg.filter(val => val?.outletName != "STP");
        this.groupByCanal(val);
      }else{
        let val = this.canalOutletListOrg;
        this.groupByCanal(val);
      }
    }

    if(!this.isVillhasCanal){

      if(this.selectedWatersourceType == 'Canal' || this.selectedWatersourceType == 'STP'){
        this.showComponent = false;
        this.showWaterCourseForm = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Info Message',
          detail: `${this.selectedWatersourceType} not found for the selected Village`,
        });
        return;
      }
    }
    if (this.selectedWatersourceType == 'Over Flow Pond') {
      this.getOverFlowPondMasterData(this.selectedVillageCode);
    }
    // this.componentSelected.Scheme_ID = '';
    // this.componentSelected.Component = '';
    // let selectedWaterSourceData = [];
    // if(args[0]== 'exists'){
    //   selectedWaterSourceData = args[1];
    // }else{
    //   // selectedWaterSourceData = this.waterSourceTypeList.filter(
    //   //   (d) => d.waterSource === this.selectedWatersourceType
    //   // )[0]?.component;
    // }
   
    
    // this.componentList = selectedWaterSourceData
    //   .map((d) => {
    //     let keys = ['MI', 'Solar', 'Pond', 'Water_Course'];
    //     if(this.selectedWatersourceType == 'Canal' ||
    //       this.selectedWatersourceType == 'STP' ||
    //       this.selectedWatersourceType == 'Over Flow Pond'
    //      ){
    //        keys = ['MI'];
    //      }
    //     let filtered = keys.filter((r) => d[r] === true);
    //     return { component: filtered.join('+'), Scheme_ID: d.Scheme_ID };
    //   })
    //   .filter((r) => r.component && r.Scheme_ID);
  }

  groupByCanal(res) {
    const groupedData = res.reduce((acc, cur) => {
      const canal = cur.canal;
      if (!acc[canal]) {
        acc[canal] = [];
      }
      acc[canal].push(cur);
      return acc;
    }, {});
  
    // Convert grouped object into array format
    this.canalOutletList = Object.keys(groupedData).map(canal => ({
      canal: canal,
      data: groupedData[canal]
    }));
  }

  onComponentSelected(event, ...args) {
    let selected = event.value;
    this.componentSelected = selected;

    let arr = this.componentSelected?.Component.split("+");
    // let arr = this.componentSelected?.SchemeCombination.split("+");
    const MI = arr.includes("MI");
    const Pond = arr.includes("Tank");
    const Solar = arr.includes("Solar");

    let reqBody = {
      AppId: this.applicationId ? this.applicationId : '',
      VillageCode: this.selectedVillageCode,
      MI: MI,
      Pond: Pond,
      Solar: Solar
    }
    this.targetStatusBody={...reqBody}

    if(args[0] == 'editMode') {
      setTimeout(() => {
        this.populateApllicationDataOnSchemeID(args[1], 'populatedScheme');
      }, 1000);
    }else{
      if(Pond){
        this.getTankTypeList();
      }
      if(Solar){
        this.getSolarMaster();
      }
    }

    // this.getTargetStatus(reqBody);
  }

  // getTargetStatus(reqBody) {
  //   this.loader.start();
  //   this._personalDetalSer.getTargetStatus(reqBody).subscribe({
  //     next: (data) => {
  //       if(data['Status'] == "Application from your district is stopped as target area for current Quarter/Year is reached"){
  //         this.isTargetReached = true;
  //         this.messageService.add({
  //           severity: 'info',
  //           summary: 'Info MessageIL',
  //           detail: data['Status'],
  //         });
  //       }else{
  //         this.isTargetReached = false;
  //       }
  //       if(data.Status!='0'){
  //         this.messageService.add({
  //           severity: 'error',
  //           summary: 'Error MessageIL',
  //           detail: `err: ${data.Status}`,
  //         });

  //       }
  //       this.loader.close();
  //     }, 
  //     error: (err) => {
  //       this.isTargetReached = false;
  //       this.loader.close();
  //       this.messageService.add({
  //         severity: 'errorIL',
  //         summary: 'Error Message',
  //         detail: err,
  //       });
  //     }
  //   })
  // }

  onApplicationTypeSelected(event, ...args) {
    this.selectedVillage = null;
    this.isVillageSelected = false;

    this.newWaterSourceTypeList = [];
    this.selectedWatersourceType = null;

    this.newComponentList = [];
    this.componentSelected = null;

    let selected = event.value;
    // this.getVillageData();
    this.applicationSelected = selected;
    this.waterSourceTypeList = [];
    this.componentList = [];

    // if(selected == 'Individual'){
    //   this.applicationSelected = 'Individual';
    // }else if(selected == 'Community'){
    //   this.applicationSelected = 'Group';
    // }else if(selected == 'WUA/GOF'){
    //   this.applicationSelected = 'WUA';
    // }

    // this.loadNewWaterSourceTypeList(this.applicationSchemeType, this.applicationSelected, ...args);

    // let selectedAppData = this.schemeMasterList.filter(
    //   (d) => d.type === selected
    // )[0]?.data;
    
    // this.loader.start();
    // of(...selectedAppData)
    //   .pipe(
    //     groupBy((p: any) => p.Source_Name),
    //     mergeMap((group$) =>
    //       group$.pipe(reduce((acc, cur) => [...acc, cur], [`${group$.key}`]))
    //     ),
    //     map((arr) => ({ waterSource: arr[0], component: arr.slice(1) })),
    //     toArray()
    //   )
    //   .subscribe((p) => {
    //     this.loader.close();
    //     this.waterSourceTypeList = p;
    //     if (this.applicationSelected == 'Individual') {
    //       // this.listAllOutletData();
    //     } else {
    //       this.canalOutletList = [];
    //     }
    //   }, error => {
    //     this.loader.close();
    //   });
  }

  onCanalOutletSelected(event) {
    let selected = event.value;
    this.outletTypeList = [];
    let selectedAppData = this.canalOutletList?.filter(
      (d) => d.canal === selected
    )[0]?.data;
    this.outletTypeList = selectedAppData;
    // if (!this.applicationId) {
    //   if (
    //     this.selectedWatersourceType == 'Canal' ||
    //     this.selectedWatersourceType == 'STP'
    //   ) {
 
    //     this.landIDList = this.selectedLandIdList?.filter(
    //       (x) => x.Village_Code == this.outletTypeList[0].villageCode
    //     );
    //   } else {
    //     this.landIDList = this.selectedLandIdList;
    //   }
    // }
  }

  editProduct(ele) {
    this.selectedMI=ele.mi;

    // this.getAllMIvenders(this.selectedMI);
    // this.onSelectMI();

    this.miApplicatonForm.reset();

    this.miApplicatonForm.patchValue({
      landId: ele.landId,
      // landId: this.landIDList.filter(r => r.Land_ID === ele.landId)[0].displayName,
      mi: ele.mi,
      // vendor: ele.vendorId,
    });
    this.addBankDialog = true;

    if(ele.vendorId){
      this.miSelectedVendor=ele.vendorId;

    }else{
      // this.loader.start();
      this.farmerAppSer
        .getAllMIvenders(ele.mi)
        .pipe(first())
        .subscribe({
          next: (res) => {
            this.miVendorList = res;
  
            let val  = res.find(val => val.Vendor_Code == ele.vendorCode);
            this.miSelectedVendor = val;
  
            // this.loader.close();
          },
          error: (err) => {
            // this.loader.close();
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: err,
            });
          },
        });
    }

      
    
  }
  editFarmersInGroup(ele) {
    // this.miApplicatonForm.reset();
    // this.miApplicatonForm.patchValue({
    //   landId: ele.Land_ID,
    //   // landId: this.landIDList.filter(r => r.Land_ID === ele.landId)[0].displayName,
    //   mi: ele.mi,
    //   vendor: ele.vendor
    // });
    this.addFarmerGroupDialog = true;
  }

  deleteProduct(ele) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        if(ele?.isEditMode == true){
          this.deleteLandDetails(ele);
        }else{
          this.miDetailsList = this.miDetailsList.filter(
            (val) => val.landId !== ele.landId
          );
        }
        if(this.miDetailsList.length==0){
          this.isDisabled=false;
        }
      },
    });
  }

  deleteFarmersInGroup(val) { 
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: `Do you want to delete record of member ${val?.farmersName} having farmer Id ${val?.farmer_Id}? Once you delete this member, all land will be deleted related to this member.`,
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: "p-button-danger p-button-text",
      rejectButtonStyleClass: "p-button-text p-button-text",
      acceptIcon: "none",
      rejectIcon: "none",

      accept: () => {
        let reqBody = {
          AppId: this.applicationId,
          FarmerId: val?.farmer_Id,
        }
        this.deleteFarmerGroupMember(reqBody);
      },
      reject: () => {
        // this.messageService.add({ severity: 'info', summary: 'Rejected', detail: 'You have rejected' });
      }
    });
  }

  deleteFarmerGroupMember(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.farmerAppSer
      .deleteFarmerGroupMember(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();

          let resp: any = res;
          if (resp == "Record deleted successfully.") {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: resp,
            });

            this.GetAllFarmerDetails(this.villageCodeFarmer);
            // this.saveFarmerToGroup();
            this.selectedFarmersLandList = this.selectedFarmersLandList.filter(
              (val) => val.farmer_Id !== reqBody.FarmerId);

          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Error Message',
              detail: resp,
            });
          }

          this.activityRecordService.activityRecord(this.farmerMobileNo, 'Delete Farmer Group Member', `${this.applicationId}`, new Date(), `${resp}`, JSON.stringify(reqBodyAfterEncypt));
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.farmerMobileNo, 'Delete Farmer Group Member (Error)', `${this.applicationId}`, new Date(), `${err}`, JSON.stringify(reqBodyAfterEncypt));
        },
      });
  }

  deleteLandDetails(ele) {
    let reqBody = {
      LandId: ele.landId,
      NetworkId: this.ipAddress,
      TerminalId: this.ipAddress,
    }

    this.loader.start();
    this.farmerAppSer.deleteLandDetailsNew(reqBody).subscribe({
      next: (data) => {
        this.loader.close();

        if (data.startsWith('Deleted')) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success Message',
            detail: 'Land Remove Successfully',
          });
          this.miDetailsList = this.miDetailsList.filter(
            (val) => val.landId !== ele.landId
          );
        } else {
          this.messageService.add({
            severity: 'info',
            summary: 'Info Message',
            detail: data,
          });
        }
      },
      error: (err) => {
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
      },
    });
  }

  hideDialog() {
    this.miApplicatonForm.reset();
    this.addBankDialog = false;
  }
  hideFarmersAddToGroupDialog() {
    this.addFarmerGroupDialog = false;
  }

  saveProduct() {
   
    let filteredLand = this.landIDList.filter((x) => {
      return x.LandID == this.miApplicatonForm.value['landId'];
    });
    this.targetStatusBody['LandId']=this.miApplicatonForm.value['landId']
    this.targetStatusBody['ProgramId'] = this.selectedMI
    this.targetStatusBody['ApplyArea'] = filteredLand[0]?.TotalArea?filteredLand[0]?.TotalArea:filteredLand[0]?.totalArea
    this.targetStatusBody['SchemeCode'] = this.componentSelected?.Scheme_ID
    this.targetStatusBody['UHBVNAppId'] = this.tubewellAppId ? this.tubewellAppId : ''
    
    // this.getTargetStatus( this.targetStatusBody);

    this.loader.start();
    this._personalDetalSer.getTargetStatus(this.targetStatusBody).subscribe({
      next: (data) => {
        if(data['Status'] != "0"){
          this.isTargetReached = true;
          this.messageService.add({
            severity: 'info',
            summary: 'Info MessageIL',
            detail: data['Status'],
          });
        }else{
          this.isTargetReached = false;

          // let vendorName = this.miVendorList.filter(
          //   (x) =>
          //     x.Vendor_Code == this.miApplicatonForm.value['vendor']['Vendor_Code']
          // )[0]?.Name;
          

          let miFarmValue = {
            mi: this.miApplicatonForm.value['mi'],
            vendor: this.miSelectedVendor? this.miSelectedVendor.Name : '',
            landId: this.miApplicatonForm.value['landId'],
            vendorId: this.miApplicatonForm.value['vendor'],
            landData: filteredLand[0]?.displayName,
            totalArea: filteredLand[0]?.TotalArea ? filteredLand[0]?.TotalArea : filteredLand[0]?.totalArea,
          };
      
          this.miDetailsList = this.miDetailsList.filter(
            (val) => val.landId !== miFarmValue.landId
          );
      
          this.miDetailsList.push(miFarmValue);
          this.miApplicatonForm.reset();
          this.addBankDialog = false;
        }
        this.loader.close();
      }, 
      error: (err) => {
        this.isTargetReached = false;
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
      }
    })
    
  }

  saveFarmerToGroup(...args) {
    this.selectedFarmersLandList = [];
    this.selectedGroupFarmersLandList = [];
    if (this.applicationSelected === 'Group') {
      let farmerIds = []
      this.selectedFarmerLandDetails.forEach(farmer => {
        farmerIds.push(farmer.Farmer_ID.toString())
      })
      this.totalNumberOfFarmersInGroup = farmerIds.length;
      if (farmerIds.length) {
        this.loader.start();
        this.ofService
          .GetFarmerPastSubsidyByMultipleFarmerIds(farmerIds)
          .pipe(first())
          .subscribe({
            next: (data) => {
              this.farmerPreviousSubsidies = data;
              this.loader.close();
            },
            error: () => {
              this.loader.close();
              this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: 'Data error! Farmer Previous Subsidies not loaded.',
              });
            },
          });
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Data error! Group-Farmers Previous Subsidies not Fetched.',
        });
        return;
      }
    }

    this.selectedFarmerLandDetails.forEach((r) => {
      r.landDetails.forEach((element) => {
        // this.selectedFarmersLandList.push({
        //   "farmer_Id": element.Farmer_ID ? element.Farmer_ID : element.farmerId,
        //   "landID": element.Land_ID ? element.Land_ID : element.LandID,
        //   "farmersName": r.Name,
        //   "village": r.vendorId ? r.venorId : r.Village_Code
        // })
        // this.selectedGroupFarmersLandList.push({
        //   "farmer_Id": element.Farmer_ID ? element.Farmer_ID : element.farmerId,
        //   "landID": element.Land_ID ? element.Land_ID : element.LandID
        // })

        let filteredLands = this.selectedFarmersLandIdList.filter((x) => {
          return (
            x.Land_ID == (element.LandID ? element.LandID : element.Land_ID)
          );
        });

        if (filteredLands.length) {
          this.selectedFarmersLandList.push({
            farmer_Id: element.Farmer_ID ? element.Farmer_ID : element.farmerId,
            landID: element.Land_ID ? element.Land_ID : element.LandID,
            farmersName: r.Name,
            // village: r.vendorId ? r.venorId : r.Village_Code,
            village: r.vendorId ? r.venorId : this.selectedVillage?.VillageName,
            land_area: element.Total_Area,
            isEditableMode: element?.isDeleteModeOnly == true ? false : true,
          });
          this.selectedGroupFarmersLandList.push({
            farmer_Id: element.Farmer_ID ? element.Farmer_ID : element.farmerId,
            landID: element.Land_ID ? element.Land_ID : element.LandID,
          });
        }
      });
    });
    this.addFarmerGroupDialog = false;
  }

  getFarmerLandByFarmerIds() {
    let farmerIds = [];
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let farmerData = farmerConfData.get('farmerDetails');

    //Here for Individual application Type
    if (this.applicationSelected === 'Individual') {
      let farmerId = farmerConfData.get('Farmer_Id_');
    
      farmerIds.push(farmerId.toString());
    } else {
      let farmerId = farmerConfData.get('Farmer_Id_');

      farmerIds.push(farmerId.toString());
      this.selectedFarmersLandList?.forEach((x) => {
        farmerIds.push(x.farmer_Id?.toString());
      });
    }

    let villageCodes = [];
    villageCodes.push(this.selectedVillageCode.toString());
    let body = {
      farmerId: farmerIds,
      villageCode: villageCodes,
      applicantType: this.applicationSelected,
    };

    this.loader.start(); 
    this.farmerAppSer.GetFarmerLandByFarmerIds(body)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data.length > 0) {
            this.landIDList = this.transformLandIDData(data);
          }else{
            this.landIDList = [];
            // this.messageService.add({
            //   severity: 'info',
            //   summary: 'Info Message',
            //   detail: `Land Data not found for this farmer`,
            // });
          }
          return;

        },
        error: (err) => {
          this.landIDList = [];
          this.loader.close();

          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: `Data error! ${err}`,
          // });
        },
      });

    // this.loader.start();
    // this.farmerAppSer.GetFarmerLandByFarmerIds(body).subscribe({
    //   next: (data) => {
    //     this.loader.close();
    //     if (data.length) {
    //       this.landIDList = this.transformLandIDData(data);
    //       return;
    //     }
    //   },
    //   error: (err) => {
    //     this.loader.close();
    //     //this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Cannot Get Farmer lands for Selected Village.' });
    //   },
    // });
  }

  openNew() {
    // this.bankAccount = {};
    // this.submitted = false;
    this.miApplicatonForm.reset();
    this.getFarmerLandByFarmerIds();
    // this.getLandIds();
    this.addBankDialog = true;
  }
  addFarmersInGroup() {
    // this.bankAccount = {};
    // this.submitted = false;
    this.addFarmerGroupDialog = true;
  }

  validateAndGetSolarVendors(...args) {
    if (
      this.solarApplicatonForm.controls.controlType.value &&
      this.solarApplicatonForm.controls.pump.value &&
      this.solarApplicatonForm.controls.pumpType.value
    ){
      //   this.solarApplicatonForm.controls.pump.value,
      //   this.solarApplicatonForm.controls.pumpType.value)
        this.getPumpCapacityList(this.solarApplicatonForm.controls.controlType.value, this.solarApplicatonForm.controls.pumpType.value, 
        this.solarApplicatonForm.controls.pump.value);
    }

    if (
      this.solarApplicatonForm.controls.controlType.value &&
      this.solarApplicatonForm.controls.pump.value &&
      this.solarApplicatonForm.controls.pumpType.value &&
      this.solarApplicatonForm.controls.pumpCapacity.value
    ){
      this.getPrimarySolarVendors(...args);
    }
  }

  getPumpCapacityList(PumpContType, PumpCategory, PumpType){
    this.loader.start();
      this.farmerAppSer
        .getPumpCapacityList(PumpContType, PumpCategory, PumpType)
        .subscribe({
          next: (data) => {
            this.loader.close();
            this.pumpCapacityList = data;
          },
          error: (err) => {
            this.loader.close();
          },
        });
  }

  onCapacityOfPumpSelected(event) {
    if (!this.solarApplicatonForm.controls.controlType.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - controlType Cant be Empty',
      });
      return;
    } else if (!this.solarApplicatonForm.controls.pump.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - pump Cant be Empty',
      });
      return;
    } else if (!this.solarApplicatonForm.controls.pumpType.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - pumpType Cant be Empty',
      });
      return;
    } else if (!this.solarApplicatonForm.controls.pumpCapacity.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - pumpCapacity Cant be Empty',
      });
      return;
    } else if (!this.solarApplicatonForm.controls.landId.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - landId Cant be Empty',
      });
    }

    this.validateAndGetSolarVendors();
  }

  getFarmerShare() {
    return this.solarMasterData.filter(
      (d: any) =>
        d.Pump_Controler_Type ===
        this.solarApplicatonForm.value['controlType'] &&
        d.Pump_Capacity === this.solarApplicatonForm.value['pumpCapacity'] &&
        d.Pump_Category === this.solarApplicatonForm.value['pumpType'] &&
        d.Pump_Type === this.solarApplicatonForm.value['pump']
    )[0];
  }

  onPondLandIdSelected(event) {
    this.selectedPondLand = event.value;
  }

  onSelectedTankType(event, ...args) {
    let selectedTankType = event.value?.Type;
    this.getTankListBasedOnType(selectedTankType, ...args);
  }

  onCoverageAreaSelected(event) {
    this.coverageAreaSelected = event.value;
    this.onFarmPondApplicatonForm.patchValue({
      topSize: this.coverageAreaSelected.Top_Size,
      bottomSize: this.coverageAreaSelected.Bottom_Size,
      depth: this.coverageAreaSelected.Depth,
      waterCapacity: this.coverageAreaSelected.Water_Capacity,
      tenativeCost: this.coverageAreaSelected.Total_Cost,
      tankId: this.coverageAreaSelected.Tank_ID,
      communityActualSubsidy: this.coverageAreaSelected.communityActualSubsidy,
      communityPayment: this.coverageAreaSelected.communityPayment,
      individualActualSubsidy: this.coverageAreaSelected.individualActualSubsidy,
      individualPayment: this.coverageAreaSelected.individualPayment,
    });
  }

  onSolarLandIdSelected(event) { }

  onVendorSelect(event) { }

  selectRow(checkValue, data) {
    if (checkValue) {
      let index = this.selectedFarmersLandIdList.indexOf(data);
      if (index == -1) {
        this.selectedFarmersLandIdList.push(data);
      }
    } else {
      let index = this.selectedFarmersLandIdList.indexOf(data);
      if (index !== -1) {
        this.selectedFarmersLandIdList.splice(index, 1);
      }
    }
  }

  selectHeaderRow(checkValue, data) {
    if (checkValue) {
      data.forEach((element) => {
        let index = this.selectedFarmersLandIdList.indexOf(element);
        if (index == -1) {
          this.selectedFarmersLandIdList.push(element);
        }
      });
    } else {
      data.forEach((element) => {
        let index = this.selectedFarmersLandIdList.indexOf(element);
        if (index !== -1) {
          this.selectedFarmersLandIdList.splice(index, 1);
        }
      });
    }
  }

  onSelectMI() {
    this.selectedProgramId = this.selectedMI
    this.getAllMIvenders(this.selectedMI);
    if(this.miDetailsList.length>0){
      this.miDetailsList.forEach(e=>{
        if(e.mi==this.selectedMI){
          this.miSelectedVendor=e.vendorId
          this.isDisabled=true;
          return;
        }
        else{
          this.isDisabled=false;
        } 
      })

    }

  }

  getAllMIvenders(programId) {
    this.loader.start();
    this.farmerAppSer
      .getAllMIvenders(programId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.miVendorList = res;
          this.loader.close();
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Category not loaded.',
          });
        },
      });
  }

  getAllOutletDataN(villageCode: any) {
    this.loader.start();
    this.farmerAppSer.GetAllOutletDetails(villageCode)
    .subscribe({
      next: (res) => {
        of(...res)
        .pipe(
          groupBy((p: any) => p.canal),
          mergeMap((group$) =>
            group$.pipe(reduce((acc, cur) => [...acc, cur], [`${group$.key}`]))
          ),
          map((arr) => ({ canal: arr[0], data: arr.slice(1) })),
          toArray()
        )
        .subscribe((p) => {
          // this.waterSourceTypeList[0].disabled = false;
          this.isVillhasCanal = true;
          this.showWaterCourseForm = true;
          this.showComponent = true;
          this.canalOutletListOrg = res;
          this.canalOutletList = p;
          this.loader.close();
          if(this.applicationId){
            this.onCanalOutletSelected({ value: this.watercourseApplicatonForm.controls.canal.value });
          }
        });
      },
      error: (err) => {
        this.isVillhasCanal = false;
        // this.waterSourceTypeList[0].disabled = true;
        this.loader.close();  
      },
    });
  }

  getIP() {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let ipAddress = farmerConfData.get('ipAddress');

    if (ipAddress) {
      this.ipAddress = ipAddress;
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;

        farmerConfData.set('ipAddress', this.ipAddress)

        const dataF = JSON.stringify(Array.from(farmerConfData.entries()));
        sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));  
      });
    }
  }

  getOverFlowPondMasterData(villCode) {
    this.loader.start();
    this.farmerAppSer
      .getOverFlowPondMaster([villCode])
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.overFlowPondList = res;
          if(this.overFlowPondList.length == 0){
            this.overFlowPondList = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data not found for selected village',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.overFlowPondList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onUHBVNToggle(val){
  }

  validateUBVNAppId(){
    this.isUHBVNAppIdFound = false;
    this.loader.start();
    this.farmerAppSer
      .getValidateUHBVNData(this.tubewellAppId, this.farmerMobileNo)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          if(res[0].result == 1){
            this.isUHBVNAppIdFound = true;
            this.showClearUHBVNButton = true;
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: 'You have applied for Tubewell connection with UHBVN.',
            });
          }else{
            this.showClearUHBVNButton = false;
            this.isUHBVNAppIdFound = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Either UHBVN App No OR applied Aadhar No is incorrect.',
            });
          }
        },
        error: (err) => {
          this.showClearUHBVNButton = false;
          this.isUHBVNAppIdFound = false;

          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  clearUBVNAppId(){
    this.tubewellAppId = null;
    this.showClearUHBVNButton = false;
    this.isUHBVNAppIdFound = false;
  }

  loadSchemeTypeList(){
    setTimeout(() => {
      this.schemeTypeList = [
        { type: 'MI', value: 'MI' },
        { type: 'Tank', value: 'Tank' },
        { type: 'Both', value: 'Both' },
      ]
    }, 100)
  }

  loadAppTypeList(){
    setTimeout(() => {
      this.applicationTypeList = [
        { type: 'Community', value: 'Group' },
        { type: 'Individual', value: 'Individual' },
        { type: 'WUA/GOF', value: 'WUA' },
      ]
    }, 100)
  }

  onApplicationSchemeTypeSelected(event, ...args) {
    this.schemeMasterList = [];
    this.applicationSelected = null;

    this.selectedVillage = null;
    this.isVillageSelected = false;

    this.newWaterSourceTypeList = [];
    this.selectedWatersourceType = null;

    this.newComponentList = [];
    this.componentSelected = null;

    // if(args[0] == 'editMode'){
    //   this.getSchemeMaster(...args);
    // }else{
    //   this.getSchemeMaster();
    // }
  }

  loadNewWaterSourceTypeList(progName, appType, ...args) {
    this.loader.start();
    this.farmerAppSer
      .getWaterSourceNew(progName, appType)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if(data.length > 0){
            this.newWaterSourceTypeList = data;
            if(args[0] == 'editMode'){
              // this.selectedWatersourceType = this.newWaterSourceTypeList.filter((val) => val.Source_Name == 'Tubewell');
              this.selectedWatersourceType = data.find((val) => val.Source_Name == args[1]?.Source_Name)?.Source_Name;

              this.onWaterSourceTypeSelected({ value: this.selectedWatersourceType}, ...args);
            }
          }else{
            this.newWaterSourceTypeList = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail:  'Water Source Type data not loaded',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.newWaterSourceTypeList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  loadNewComponentList(waterSourceId, applicantType, schemeType, ...args) {
    this.loader.start();
    this.farmerAppSer
      .getSchemeMasterNew(waterSourceId, applicantType, schemeType)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if(data.length > 0){
            this.newComponentList = data;

            if(args[0] == 'editMode'){
              this.componentSelected = data.filter((val) => val.Scheme_ID == args[1].Scheme_ID)[0];
              this.onComponentSelected({ value: this.componentSelected }, ...args);
            }
          }else{
            this.newComponentList = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail:  'Water Source Type data not loaded',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.newComponentList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }
}
